import { styled } from '@mui/styles';
import Box from '@mui/material/Box';

export const StyledShareFundraiserModal = styled(Box)(({ theme }) => ({
	paddingBottom: '20px',

	'& .QrCodeSection': {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: '8px',
		marginBottom: '24px',
	},

	'& .QrDownloadTrigger': {
		fontWeight: 700,
		color: '#00884C',
		cursor: 'pointer',
		'&:hover': {
			textDecoration: 'underline',
		},
	},

	'& .IconsStack': {
		display: 'grid',
		gridTemplateColumns: 'repeat(5, 1fr)',
		columnGap: theme.spacing(2),
		textAlign: 'center',
		'& .react-share__ShareButton': {
			display: 'flex',
			flexDirection: 'column',
			gap: '5px',
			alignItems: 'center',
			justifyContent: 'flex-end',
			width: '100%',
		},
	},

	'& .CopyUrlStack': {
		gap: '8px',
	},

	'& .CopyUrlBox': {
		display: 'flex',
		alignItems: 'stretch',
		border: `1px solid ${theme.palette.divider}`,
		borderRadius: '10px',
		overflow: 'hidden',
		backgroundColor: '#F7F8F8',
	},

	'& .CopyUrlText': {
		flex: '1 1 auto',
		minWidth: 0,
		display: 'block',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		padding: '12px 16px',
		color: theme.palette.text.secondary,
		fontSize: '0.9rem',
	},

	'& .CopyUrlButton': {
		borderRadius: 0,
		margin: 0,
		flex: '0 0 auto',
		width: '48px',
		minWidth: '48px',
		backgroundColor: '#005F35',
		color: '#fff',
		'&:hover': {
			backgroundColor: '#00492A',
		},
	},
}));
